/**
 * Back-office de plateforme.
 *
 * Une seule page utile : les restaurants. Tout le reste appartient au
 * back-office du restaurant, qui est une autre application.
 * Voir docs/adr/0015-back-office-de-plateforme-separe.md.
 */

import { AuthProvider, useAuth } from './auth/context.js';
import { labels } from './labels.js';
import { Logo } from './components/Logo.js';
import { PlatformLayout } from './components/PlatformLayout.js';
import { LoginPage } from './pages/LoginPage.js';
import { RestaurantsPage } from './pages/RestaurantsPage.js';

function Shell() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <main className="empty-state" style={{ minHeight: '100dvh', justifyContent: 'center' }} aria-busy="true">
        <Logo size={48} />
        <p className="empty-state__text">{labels.auth.restoring}</p>
      </main>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <PlatformLayout user={user} onSignOut={() => void logout()}>
      <RestaurantsPage />
    </PlatformLayout>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
